module.exports = __webpack_public_path__ + "static/img/1.9e2cdb1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/2/1/zh/1.png
// module id = 1LCB
// module chunks = 0